import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/delivery-cost')({
  component: AdminDeliveryCostRoute,
});

function AdminDeliveryCostRoute() {
  return <Outlet />;
}
